import { GetEmployeeBalanceResponse } from '@Common/types/b2b/balance';
import { GetB2bEmployeesOneResponse } from '@Common/types/bo/b2b/employees';
import { B2bCompanyPlanTypeParameters } from '@Common/types/bo/b2b/plans';

import { b2bEmployeesTranslations } from '@sh4res/bo-common/i18n/fr/b2b/employees';

import { employeesTranslations as employeesTranslationsEn } from '@I18n/en/employees';

export const employeesTranslations = {
  subtitle: 'Numéro de compte #%{id}',
  fields: b2bEmployeesTranslations.fields,
  status: {
    current: 'Présent',
    past: 'Sorti',
    retired: 'Retraité',
  } satisfies Record<GetB2bEmployeesOneResponse['status'], string>,
  social_status: {
    TS: 'TS',
    TNS: 'TNS',
  } satisfies Record<GetB2bEmployeesOneResponse['social_status'], string>,
  leaving_reason: {
    decease: 'Décès',
    job_transfer: 'Muté',
    other: 'Autre',
    retirement: 'Retraite',
    work_ended: 'Fin de contrat de travail',
  } satisfies Record<Exclude<GetB2bEmployeesOneResponse['leaving_reason'], null>, string>,
  tabs: {
    details: {
      label: 'Détails',
      sections: {
        details: 'Détails',
        personal: 'Information personnelle',
        work: 'Travail',
        company: 'Entreprise',
        financial: 'Information Financière',
        account: 'Compte',
      },
    },
    orders: {
      label: 'Ordres',
      error: 'Échec de la récupération des ordres des adhérents',
      no_plans: "Aucun plan n'est encore mis en place pour l'entreprise",
    },
    savings: {
      label: 'Épargnes',
      no_plans: "Aucun plan n'est encore mis en place pour l'entreprise",
      not_linked: 'Employee has not been linked yet to any Shares user',
      sections: {
        balance: 'Balance',
        portfolio: 'Portfefeuille',
      },
    },
    abondements: {
      label: 'Abondements',
      error: 'Échec de la récupération des abonnements des adhérents',
      no_plans: "Aucun plan n'est encore mis en place pour l'entreprise",
      no_eligible_plans:
        'L’utilisateur n’est pas éligible à un abondement de la part de l’entreprise',
      employment_inactive:
        "L'adhérent n'est plus éligible aux abondements de l'entreprise car il a mis fin à son contrat de travail",
      matching_contribution: 'Abondement',
      this_plan: 'Ce plan',
      remaining: 'Restant',
      available_until: 'Disponible jusqu’au',
      annual_ceiling: 'Plafond annuel du plan',
      legal_ceiling: 'Plafond légal (%{percentage} % du PASS)',
      matching_rate: 'Taux d’abondement',
      plan_type: {
        PEI: B2bCompanyPlanTypeParameters.PEI.name,
        PERECOI: B2bCompanyPlanTypeParameters.PERECOI.name,
      },
    },
  },
  balance: {
    fields: {
      id: 'ID',
      withdrawable_balance: 'Fonds disponibles',
      booked_in_orders: 'Bloqué par les ordres',
      total_balance: 'Fonds',
      locked_balance: 'Fonds bloqués',
      unsettled_balance: 'Unsettled Cash',
      user_id: 'ID utilisateur',
      currency: 'Devise',
    } satisfies Record<keyof GetEmployeeBalanceResponse, string>,
  },
} satisfies typeof employeesTranslationsEn;
